<template>
  <div class="tva-row anteprima-container">
    <img class="copertina" :src="content.copertina" alt="">
    <div id="btn-link-preview" class="btn-cta" @click="clickBtnPagePodcast">
      <div v-html="content.text_cta"></div>
    </div>
    <div class="text-extra" v-html="content.text_extra"></div>
  </div>
</template>
<script>
import gsap from "gsap";
import { TimelineMax } from 'gsap'
export default {
  props: ["content"],
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    clickBtnAnteprima(){
      dataLayer.push({'event': 'button1-click'});
      window.open(this.content.link_anteprima, "_blank");
    },
    clickBtnPagePodcast(){
      dataLayer.push({'event': 'button2-click'});
      window.open(this.content.link_cta, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/bootstrap-grid.scss";
@import "@/assets/scss/fonts.scss";
.anteprima-container{
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .copertina{
    width: 350px;
    padding-top: 100px;
  }
  .btn-cta{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 55px;
    width: 350px;
    border: 2px solid $mdf-darkblue;
    background-color: $mdf-darkblue;
    box-shadow: 0 0 10px 1px $mdf-white;
    margin-top: 21px;
    cursor: pointer;
    @include mdf-cta-text;
  }
  .text-extra{
    padding-top: 24px;
    padding-bottom: 100px;
    @include mdf-copyright;
  }
}

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .anteprima-container{
    .copertina {
      width: 250px;
      padding-top: 56px;
    }
    .btn-cta{
      width: 250px;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 1px;
    }
    .text-extra{
      font-size: 14px;
      text-align: center;
      line-height: 21px;
      padding-bottom: 72px;
    }
  }
}
</style>
